import { KeywordCloud } from "Explore/Components";
import ScholarsAndPeers from "../ScholarsAndPeers/ScholarsAndPeers";
import styles from "./AcademicInformation.module.scss";
import NotableConcepts from "../NotableConcepts";
import { useRef, useState } from "react";
import { useEffect } from "react";
import {
  getInstitutionGrantsKeywordsByID,
  getInstitutionScholarKeywordsByID,
} from "Explore/Services/Institution";
import { getRelatedKeywords } from "Explore/Services/Common";
import RelatedInstitutions from "../RelatedInstitutions";
import { Container } from "@mui/material";

const AcademicInformation = ({
  institution_id,
  landscape,
  selectedKeywords,
  setSelectedKeywords,
  selectedKeywordsQueue,
  setSelectedKeywordsQueue,
  granularityLevel,
  setGranularityLevel,
  sliderValue,
  setSliderValue,
  scholars,
  setScholars,
  // publications,
  publicationVerify,
  setPublicationVerify,
  awards,
  peers,
  tab,
  setTab,
  facultySearchFilter,
  setFacultySearchFilter,
  grantsFilter,
  setGrantsFilter,
  selectedDepartment,
  pagination,
  setPagination,
  notableConcepts,
  showLoginSection,
}) => {
  const [exploringKeyword, setExploringKeyword] = useState(null);
  const [concept, setConcept] = useState({ data: [], isLoading: true });
  const [granularityLevelQueue, setGranularityLevelQueue] = useState([]);
  const keywordRef = useRef(null);
  const prevExploringKeyword = useRef(null);

  // useEffect(() => {
  //   if (!!exploringKeyword) {
  //     if (exploringKeyword !== prevExploringKeyword.current) {
  //       setConcept({ data: [], isLoading: true });
  //       setSelectedKeywordsQueue([]);
  //       setSelectedKeywords([exploringKeyword]);
  //       getRelatedKeywords({
  //         entity: "institutions",
  //         keywords: [exploringKeyword.name],
  //       }).then((res) => {
  //         setConcept({ data: [exploringKeyword, ...res], isLoading: false });
  //       });
  //     } else if (selectedKeywords.length === 0) {
  //       getNewConceptData();
  //       setExploringKeyword(null);
  //     }
  //   }
  //   prevExploringKeyword.current = exploringKeyword;
  // }, [exploringKeyword, selectedKeywords]);

  useEffect(() => {
    if (!institution_id) return;
    if (prevExploringKeyword.current !== exploringKeyword) {
      setConcept({ data: [], isLoading: true });
      setSelectedKeywordsQueue([[exploringKeyword]]);
      setSelectedKeywords([exploringKeyword]);
      setGranularityLevel(exploringKeyword.level + 2);
      setGranularityLevelQueue([1]);
      prevExploringKeyword.current = exploringKeyword;
    } else {
      setConcept({ data: [], isLoading: true });
      let params = new URLSearchParams();
      (selectedKeywordsQueue[selectedKeywordsQueue.length - 1] || []).forEach(
        (keyword) => {
          if (keyword) {
            params.append("rootConcept", keyword.value);
          }
        }
      );
      if (params.toString().length > 0) {
        params = params.toString();
      } else {
        params = null;
      }
      if (tab === "grants") {
        getInstitutionGrantsKeywordsByID(
          institution_id,
          sliderValue[0],
          sliderValue[1],
          granularityLevel,
          params,
          (res) => {
            setConcept({ data: res.keywords, isLoading: false });
          }
        );
      } else {
        getInstitutionScholarKeywordsByID(
          institution_id,
          sliderValue[0],
          sliderValue[1],
          granularityLevel,
          params,
          null,
          (res) => {
            setConcept({ data: res.keywords, isLoading: false });
          }
        );
      }
    }
  }, [
    institution_id,
    exploringKeyword,
    selectedKeywordsQueue,
    sliderValue,
    granularityLevel,
    tab,
  ]);

  // const getNewConceptData = () => {
  //   setConcept({ data: [], isLoading: true });
  //   let params = new URLSearchParams();
  //   (selectedKeywordsQueue[selectedKeywordsQueue.length - 1] || []).forEach(
  //     (keyword) => {
  //       if (keyword) {
  //         params.append("rootConcept", keyword.value);
  //       }
  //     }
  //   );
  //   if (params.toString().length > 0) {
  //     params = params.toString();
  //   } else {
  //     params = null;
  //   }
  //   if (tab === "grants") {
  //     getInstitutionGrantsKeywordsByID(
  //       institution_id,
  //       sliderValue[0],
  //       sliderValue[1],
  //       granularityLevel,
  //       params,
  //       (res) => {
  //         setConcept({ data: res.keywords, isLoading: false });
  //       }
  //     );
  //   } else {
  //     getInstitutionScholarKeywordsByID(
  //       institution_id,
  //       sliderValue[0],
  //       sliderValue[1],
  //       granularityLevel,
  //       params,
  //       null,
  //       (res) => {
  //         setConcept({ data: res.keywords, isLoading: false });
  //       }
  //     );
  //   }
  // };

  const onClickExploreKeywordCallback = (keyword) => {
    setExploringKeyword(keyword);
    if (keywordRef.current) {
      keywordRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <section className={styles["section"]}>
        <Container maxWidth="lg">
          <NotableConcepts
            notableConcepts={notableConcepts}
            onClickExploreKeywordCallback={onClickExploreKeywordCallback}
            selectedKeywords={selectedKeywords}
          />
        </Container>
      </section>

      <section className={`${styles["section"]} ${styles["section--alt"]}`}>
        <Container maxWidth="lg">
          <div
            ref={keywordRef}
            className={styles["word-cloud"]}
          >
            <KeywordCloud
              concept={concept}
              selectedKeywords={selectedKeywords}
              setSelectedKeywords={setSelectedKeywords}
              granularityLevel={granularityLevel}
              setGranularityLevel={setGranularityLevel}
              granularityLevelQueue={granularityLevelQueue}
              setGranularityLevelQueue={setGranularityLevelQueue}
              selectedKeywordsQueue={selectedKeywordsQueue}
              setSelectedKeywordsQueue={setSelectedKeywordsQueue}
              sliderValue={sliderValue}
              setSliderValue={setSliderValue}
              chart_width={
                window.screen.width < 1024
                  ? window.screen.width < 480
                    ? null
                    : 500
                  : ""
              }
            />
          </div>
        </Container>
      </section>

      <section className={styles["section"]}>
        <Container maxWidth="lg">
          <ScholarsAndPeers
            scholars={scholars}
            setScholars={setScholars}
            // publications={publications}
            publicationVerify={publicationVerify}
            setPublicationVerify={setPublicationVerify}
            awards={awards}
            peers={peers}
            tab={tab}
            setTab={setTab}
            institution_id={institution_id}
            landscape={landscape}
            facultySearchFilter={facultySearchFilter}
            setFacultySearchFilter={setFacultySearchFilter}
            grantsFilter={grantsFilter}
            setGrantsFilter={setGrantsFilter}
            selectedKeywords={selectedKeywords}
            setSelectedKeywords={setSelectedKeywords}
            selectedKeywordsQueue={selectedKeywordsQueue}
            selectedDepartment={selectedDepartment}
            sliderValue={sliderValue}
            pagination={pagination}
            setPagination={setPagination}
            showLoginSection={showLoginSection}
          />
        </Container>
      </section>

      <section className={`${styles["section"]} ${styles["section--alt"]}`}>
        <Container maxWidth="lg">
          <RelatedInstitutions />
        </Container>
      </section>
    </>
  );
};

export default AcademicInformation;
